<template>
    <div class="content">
        <topWell />
        <div class="mainBox">
            <listNav :title="pageType === 'search' ? $route.query.pageName + ' > ' + detData.title : pageType === 'djgz' ?
                pageTitle + ' > ' + (detData.title ? detData.title : '') : pageTitle + ' > ' + $route.query.pageName + ' > ' +
                (detData.title ? detData.title : '')" :navData="[]" @checkPageInd="checkPageInd" />
            <div class="info">
                <div class="title">
                    {{ detData ? detData.title : '' }}
                </div>
                <div class="date">发布时间：{{ detData ? detData.createTime : '' }}</div>
                <div class="img"></div>
                <div class="des ql-editor" v-html="detData ? detData.content : ''">
                </div>
            </div>
            <div class="page" v-if="prevData.length != 0 || nextData.length != 0">
                <div class="btn prev" @click="jumpDet(prevData)">
                    <template v-if="prevData">上一篇：{{ prevData.title }}</template>
                </div>
                <div class="btn next" @click="jumpDet(nextData)" style="text-align: right;">
                    <template v-if="nextData">下一篇：{{ nextData.title }}</template>
                </div>
            </div>
            <div class="news" v-if="list.length != 0">
                <div class="title">相关文章</div>
                <div class="list">
                    <div class="item" v-for="v of list" :key="v.id" @click="jumpDet(v)">
                        <div class="name">{{ v.title }}</div>
                        <div class="date">{{ v.createTime ? v.createTime.substring(10, 0) : "" }}</div>
                    </div>
                </div>
            </div>
        </div>
        <bottomNav />
    </div>
</template>

<script>
import topWell from "@/views/topWheel/topWheel.vue";
import bottomNav from "@/views/bottomNav/bottomNav.vue";
import listNav from "../../components/listNav.vue";
import { htmlSplice } from "../../../utils/common";

export default {
    components: {
        topWell,
        bottomNav,
        listNav
    },
    data() {
        return {
            classData: [], // 新闻分类
            pageInd: 0,
            pageType: this.$route.query.pageType,
            detData: {},
            pageTitle: '',
            list: [],
            prevData: [],
            nextData: [],
        };
    },
    watch: {
        $route() {
            // 监听路由变化并检查
            this.checkRouteForProject();
        },
    },
    created() {
        window.scrollTo({
            top: 0,
            left: 0,
            // behavior: 'smooth' // 平滑滚动
        });
        if (this.pageType === 'xwzx') {
            this.pageTitle = '新闻中心'
        }
        if (this.pageType === 'gkgs') {
            this.pageTitle = '公示公告'
        }
        if (this.pageType === 'zcfg') {
            this.pageTitle = '政策法规'
        }
        if (this.pageType === 'djgz') {
            this.pageTitle = '党建工作'
        }
        if (this.pageType === 'ywbk') {
            this.pageTitle = '业务板块'
        }
        this.getPressClassifyData();
        this.getData();
        this.getListData()
    },
    methods: {
        // 跳转新闻详情
        jumpDet(v) {
            this.$router.push({
                path: "/articleDet", query: {
                    pageType: this.pageType,
                    pageName: this.$route.query.pageName,
                    ...v
                }
            });
        },
        checkRouteForProject() {
            this.pageType = this.$route.query.pageType;
            this.getPressClassifyData();
            this.getData();
            this.getListData()
        },
        checkPageInd() {
            // this.$router.replace({})
        },
        // 获取新闻分类
        getPressClassifyData() {
            if (this.pageType === "xwzx") {
                this.$api.getPressClassifyApi().then((res) => {
                    this.classData = res.data;
                });
            }
            if (this.pageType === "gkgs") {
                this.$api.getAnnouncementClassifyApi().then((res) => {
                    this.classData = res.data;
                });
            }
            if (this.pageType === "zcfg") {
                this.$api.getProjectClassify().then((res) => {
                    this.classData = res.data;
                });
            }
        },
        // 获取新闻列表
        getListData() {
            if (this.pageType === "xwzx" || this.pageType === "search") {
                this.$api.getpressCenterApi({
                    pageSize: 8,
                    pageNum: 1,
                    classify: ''
                }).then((res) => {
                    this.list = res.rows;
                    this.list = this.list.filter((v) => {
                        v.content = htmlSplice(v.content);
                        return v;
                    });
                });
            }
            if (this.pageType === 'gkgs') {
                this.$api.getAnnouncementApi({
                    pageSize: 8,
                    pageNum: 1,
                    classify: ''
                }).then((res) => {
                    this.list = res.rows;
                    this.list = this.list.filter((v) => {
                        v.content = htmlSplice(v.content);
                        return v;
                    });
                });
            }
            if (this.pageType === 'djgz') {
                this.$api.getPartyBuilding({
                    pageSize: 8,
                    pageNum: 1,
                    classify: ''
                }).then(res => {
                    this.list = res.rows;
                    this.list = this.list.filter((v) => {
                        v.content = htmlSplice(v.content);
                        return v;
                    });
                })
            }
            if (this.pageType === 'zcfg') {
                this.$api.getpolicyList({
                    pageSize: 8,
                    pageNum: 1,
                    classify: ''
                }).then(res => {
                    this.list = res.rows;
                    this.list = this.list.filter((v) => {
                        v.content = htmlSplice(v.content);
                        return v;
                    });
                })
            }
        },
        // 获取文章详情
        getData() {
            if (this.pageType === 'search') {
                this.$api.getpressCenterDet({
                    id: this.$route.query.id
                }).then(res => {
                    this.detData = res.data
                    if (res.data.upPress) this.prevData = res.data.upPress
                    if (res.data.nextPress) this.nextData = res.data.nextPress
                })
            }
            if (this.pageType === 'xwzx') {
                this.$api.getpressCenterDet({
                    id: this.$route.query.id
                }).then(res => {
                    this.detData = res.data
                    if (res.data.upPress) this.prevData = res.data.upPress
                    if (res.data.nextPress) this.nextData = res.data.nextPress
                })
            }
            if (this.pageType === 'gkgs') {
                this.$api.getAnnouncementDetApi({
                    id: this.$route.query.id
                }).then(res => {
                    this.detData = res.data
                    if (res.data.upAnnouncement) this.prevData = res.data.upAnnouncement
                    if (res.data.nextAnnouncement) this.nextData = res.data.nextAnnouncement
                })
            }
            if (this.pageType === 'zcfg') {
                this.$api.getpolicyDet({
                    id: this.$route.query.id
                }).then(res => {
                    this.detData = res.data
                    if (res.data.upPolicy) this.prevData = res.data.upPolicy
                    if (res.data.nextPolicy) this.nextData = res.data.nextPolicy
                })
            }
            if (this.pageType === 'djgz') {
                this.$api.getPartyBuildingDet({
                    id: this.$route.query.id
                }).then(res => {
                    this.detData = res.data
                    if (res.data.upPartyBuilding) this.prevData = res.data.upPartyBuilding
                    if (res.data.nextPartyBuilding) this.nextData = res.data.nextPartyBuilding
                })
            }
            if (this.pageType == 'ywbk') {
                this.$api.getbusiness({
                    id: this.$route.query.id
                }).then(res => {
                    res.data.title = res.data.name
                    this.detData = res.data
                })
            }
        }
    },
};
</script>
<style scoped lang="less">
@normal-width: 93.75rem;

.mainBox {
    font-size: 18px;
    font-family: '思源黑体';
}

.info {
    padding: 80px 6.5rem
        /* 104/16 */
    ;
    min-width: @normal-width;
    width: @normal-width;
    margin: 0 auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    color: #666666;
    font-size: 18px;
    line-height: 36px;

    .title {
        color: #121e46;
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 36px;
    }

    .date {
        color: #333333;
        font-size: 18px;
        margin-bottom: 58px;
    }

    img {
        max-width: 80%;
    }

    .des {
        width: 100%;
    }
}

.page {
    padding: 40px 6.5rem
        /* 104/16 */
    ;
    min-width: @normal-width;
    width: @normal-width;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #666666;
    font-size: 18px;
    border-top: 1px solid #ececec;

    .btn {
        cursor: pointer;
        width: 48%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
}

.news {
    padding: 40px 6.5rem
        /* 104/16 */
    ;
    min-width: @normal-width;
    width: @normal-width;
    margin: 0 auto;
    padding-bottom: 100px;

    .title {
        color: #1e439b;
        font-size: 20px;
        font-weight: bold;
        // margin-bottom: 50px;
    }

    .list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;

        .item {
            width: 48%;
            padding: 14px 0;
            padding-top: 30px;
            border-bottom: 1px solid #ececec;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;

            .name {
                width: 80%;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }

            &:hover {
                color: #1e439b;
            }
        }
    }
}
</style>
